<template>
  <div class="page-wrapper-payments">
    <div class="page-half-wrapper page-half-wrapper-left">

      <div class="header expense-details">
        <span class="expense-details-text">{{ $lang.messages.expenseDetails }}</span>
        <div class="expense-details-btns" v-click-outside="noHandlePaymentDropdown">
          <img
              src="@/assets/images/payments/actions_ico.png"
              alt="kebab icon"
              @click="handlePaymentDropdown"
          >
          <div :class="{'show-payments-dropdown': payDropMenu}">
            <button
              @click="deleteModalOpen(payment.guid, 'payment', 'deleteExpense')"
              class="generic-btn"
              :disabled="
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                payment.paymentStatus === 'REJECTED' ||
                !payment.changeable
              "
              :class="[
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                payment.paymentStatus === 'REJECTED' ||
                !payment.changeable ? 'disabled' : ''
              ]"
            >
              {{ $lang.messages.deleteExpense }}
            </button>
            <button
              class="generic-btn edit-expense"
              :disabled="
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                payment.paymentStatus === 'REJECTED' ||
                !payment.changeable
              "
              :class="[
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                payment.paymentStatus === 'REJECTED' ||
                !payment.changeable ? 'disabled' : ''
              ]"
            >
              <router-link
                v-if="
                  payment.paymentStatus === 'NOT_PAID' && payment.changeable
                "
                :to="{ name: computedRoute(payment.expenseType),  params: { id: payment.guid }, query: { type: 'onetime' } }"
              >
                {{ $lang.messages.editExpense }}
              </router-link>
              <span v-if="
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                payment.paymentStatus === 'REJECTED' ||
                !payment.changeable
              ">
                {{ $lang.messages.editExpense }}
              </span>
            </button>
            <button
              @click="confimationModalOpen(payment.guid)"
              class="generic-btn"
              :disabled="
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                !payment.canMarkAsPaid
              "
              :class="[
                payment.paymentStatus === 'PAID' ||
                payment.paymentStatus === 'PAID_EXTERNALLY' ||
                payment.paymentStatus === 'DIGITAL_CHECK' ||
                payment.paymentStatus === 'PENDING' ||
                !payment.canMarkAsPaid ? 'disabled' : ''
              ]"
              :title="$lang.messages.markAsPaidDescription"
            >
              {{ $lang.messages.markAsPaid }}
            </button>
            <div class="btn-pay-container">
              <button
                class="action-btn pay-button"
                @click="showPayExpenseModal"
                :disabled="payment.payable === false && checkedExpenses.length >= 1"
                :class="{'disabled' : payment.payable === false && checkedExpenses.length >= 1}"
              >
                <span>{{ $lang.messages.pay }}</span>
              </button>
              <div class="not-payable-reason-mask" v-if="!payment.payable"></div>
              <div class="not-payable-reason" v-if="!payment.payable">
                <p>
                  {{ payment.notPayableReasonTxtPart1 }}
                  <router-link
                    v-if="payment.notPayableReasonUrl"
                    :to="{ name: payment.notPayableReasonUrl }"
                  >
                    {{ $lang.messages.tp_paymentsMethods }}
                  </router-link>
                  {{ payment.notPayableReasonTxtPart2 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="type !== $SHARED_EXPENSE_TYPE"
        class="section-row"
      >
        <hr class="horizontal-line">
        <div class="half-section-row">
          <div class="part amount">
            <div class="label input-filter-label">{{ $lang.messages.amount }}</div>
            <div class="info special-info">
              <currency-sign :currency="payment.currency"></currency-sign>{{ currencyFormat(payment.amount) }}
            </div>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.paymentStatus }}</div>
            <span v-if="payment.paymentStatus === 'PAID'">
              <button class="lbl lbl-paid uppercase-text">
                {{ '✓ ' + $lang.messages.paid }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'PAID_EXTERNALLY'">
              <button class="lbl lbl-paid-externally uppercase-text">
                {{ '✓ ' + $lang.messages.paidExternally }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'DIGITAL_CHECK'">
              <button class="lbl lbl-paid-externally uppercase-text">
                {{ '✓ ' + $lang.messages.digitalCheck }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'NOT_PAID'">
              <button class="lbl lbl-unpaid uppercase-text">
                {{ $lang.messages.unpaid }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'PENDING'">
              <button class="lbl lbl-pending uppercase-text">
                {{ $lang.messages.pending }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'REJECTED'">
              <button class="lbl lbl-rejected uppercase-text">
                {{ $lang.messages.rejected }}
              </button>
            </span>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.date }}</div>
            <span class="info">{{ dateFormat(payment.date) }}</span>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.scheduled }}</div>
            <div class="info">{{ payment.scheduled }}</div>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.paymentReferenceNumber }}</div>
            <div class="info">{{ payment.guid }}</div>
          </div>
        </div>
        <div class="half-section-row">
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.submittedBy }}</div>
            <div class="info">{{ payment.submittedBy.name }}</div>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.payor }}</div>
            <div class="info">{{ payment.payor.name }}</div>
          </div>
          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.recipient }}</div>
            <div class="info">{{ payment.recipient.name }}</div>
          </div>
          <div
              v-if="type === $CHILD_EXPENSE_TYPE"
              class="part"
          >
            <div class="label input-filter-label">{{ $lang.messages.children }}</div>
            <div class="info">{{ payment.children }}</div>
          </div>
        </div>
      </div>

      <div
        v-if="type === $SHARED_EXPENSE_TYPE"
        class="section-row"
      >
        <div class="half-section-row original-payment">
          <p class="payment-type uppercase-text">
            {{ $lang.messages.originalPaymentPart1 }}
            <br>
            {{ $lang.messages.originalPaymentPart2 }}
          </p>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.amount }}</div>
            <div class="info special-info">
              <currency-sign :currency="payment.currency"></currency-sign>{{ currencyFormat(payment.totalAmount) }}
            </div>
          </div>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.paidBy }}</div>
            <div class="info">{{ payment.paidBy.name }}</div>
          </div>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.date }}</div>
            <span class="info">{{ dateFormat(payment.originalPaymentDate) }}</span>
          </div>
        </div>

        <div class="half-section-row reimbursement-payment">
          <p class="payment-type uppercase-text">{{ $lang.messages.reimbursementPayment }}</p>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.amount }}</div>
            <div class="info special-info">
              <currency-sign :currency="payment.currency"></currency-sign>{{ currencyFormat(payment.reimbursementAmount) }}
            </div>
          </div>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.owedBy }}</div>
            <div class="info">{{ payment.owedBy.name }}</div>
          </div>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.date }}</div>
            <span class="info">{{ dateFormat(payment.reimbursementPaymentDate) }}</span>
          </div>

          <div class="part">
            <div class="label input-filter-label">{{ $lang.messages.paymentStatus }}</div>
            <span v-if="payment.paymentStatus === 'PAID'">
              <button class="lbl lbl-paid uppercase-text">
                {{ '✓ ' + $lang.messages.paid }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'PAID_EXTERNALLY'">
              <button class="lbl lbl-paid-externally uppercase-text">
                {{ '✓ ' + $lang.messages.paidExternally }}
               </button>
            </span>
            <span v-if="payment.paymentStatus === 'DIGITAL_CHECK'">
              <button class="lbl lbl-paid-externally uppercase-text">
                {{ '✓ ' + $lang.messages.digitalCheck }}
               </button>
            </span>
            <span v-if="payment.paymentStatus === 'NOT_PAID'">
              <button class="lbl lbl-unpaid uppercase-text">
                {{ $lang.messages.unpaid }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'PENDING'">
              <button class="lbl lbl-pending uppercase-text">
                {{ $lang.messages.pending }}
              </button>
            </span>
            <span v-if="payment.paymentStatus === 'REJECTED'">
              <button class="lbl lbl-rejected uppercase-text">
                {{ $lang.messages.rejected }}
              </button>
            </span>
          </div>
        </div>
      </div>

      <div
        v-if="type === $SHARED_EXPENSE_TYPE"
        class="section-row share-row"
      >
        <span>
          {{ $lang.messages.yourShare }}:
          <currency-sign :currency="payment.currency"></currency-sign>
          {{ currencyFormat(payment.totalAmount - payment.reimbursementAmount) }}
          ({{ payment.myShare }}%)
        </span>
        <span> / </span>
         <span>
           {{ $lang.messages.coparentsShare }}:
           <currency-sign :currency="payment.currency"></currency-sign>
           {{ currencyFormat(payment.reimbursementAmount) }}
           ({{ payment.coparentsShare }}%)
         </span>
      </div>

      <div
        v-if="type === $SHARED_EXPENSE_TYPE"
        class="section-row"
      >
        <div class="part">
          <div class="label input-filter-label">{{ $lang.messages.submittedBy }}</div>
          <div class="info">{{ payment.submittedBy.name }}</div>
        </div>
        <div class="part">
          <div class="label input-filter-label">{{ $lang.messages.scheduled }}</div>
          <div class="info">{{ payment.scheduled }}</div>
        </div>
        <div class="part">
          <div class="label input-filter-label">{{ $lang.messages.paymentReferenceNumber }}</div>
          <div class="info">{{ payment.guid }}</div>
        </div>
      </div>

      <div class="section-row" v-if="payment.note !== null">
        <hr class="horizontal-line">
        <div class="part">
          <div class="label input-filter-label">{{ $lang.messages.notePrivate }}</div>
          <div class="info">{{ payment.note }}</div>
        </div>
      </div>

      <div class="section-row" v-if="payment.attachments.length !== 0">
        <hr class="horizontal-line">

        <f-p-input-download
          :inputDownloadText="$lang.messages.download"
          :attachmentResponse="payment.attachments"
          :isRecExpenseDetails="false"
        >
          <p class="label">
            {{ $lang.messages.attachments }}
          </p>
        </f-p-input-download>

      </div>
    </div>

    <div class="page-half-wrapper">
      <discussion
        v-if="payment.guid !== ''"
        :guid="payment.guid"
        :commentCountProp="payment.commentCount"
        :discuss="discuss">
      </discussion>
    </div>

    <!-- Delete Modal -->
    <delete-modal
      ref="deleteModalComponent"
      @deleteExpense="deleteExpense">
    </delete-modal>
    <!-- Mark As Paid Modal -->
    <confirmation-modal
      :modalTitle="$lang.messages.markAsPaid"
      :text="$lang.messages.surePayment + '?'"
      :buttonText="$lang.messages.markAsPaid"
      ref="confirmationModal"
      @emitAction="markAsPaid">
    </confirmation-modal>
    <!-- Pay Expense modal -->
    <f-p-pay-expense-modal
      ref="payExpenseDetails"
      :nameProp="'payExpenseDetails'"
      @loadExpenses="getExpense">
    </f-p-pay-expense-modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import {
    SHARED_EXPENSES_FIND_BY_GUID,
    CHILD_MAINTENANCE_FIND_BY_GUID,
    SPOUSAL_MAINTENANCE_FIND_BY_GUID,
    DELETE_EXPENSE,
    MARK_AS_PAID
  } from '@/store/action.types';
  import { currencyFormat } from "@/mixins/currencyFormat";
  import {dateFormat} from "@/mixins/dateFormat";
  import Discussion from '@/components/common/Discussion';
  import FPPayExpenseModal from '@/components/common/modals/FPPayExpenseModal';
  import CurrencySign from '@/components/common/CurrencySign';
  import DeleteModal from '@/components/common/modals/DeleteModal';
  import ConfirmationModal from '@/components/common/modals/ConfirmationModal';
  import FPInputDownload from '@/components/common/inputs/FPInputDownload';
  import vClickOutside from 'v-click-outside';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "FpExpenseDetails",
    components: {
      ConfirmationModal,
      Discussion,
      FPPayExpenseModal,
      CurrencySign,
      DeleteModal,
      'f-p-input-download': FPInputDownload
    },
    mixins: [
      currencyFormat,
      dateFormat
    ],
    directives: {
      clickOutside: vClickOutside.directive
    },
    props: {
      guid: {
        type: String,
        required: true,
        default: () => ''
      },
      queryPay: {
        type: Boolean,
        required: true,
        default: () => false
      },
      type: {
        type: String,
        required: true,
        default: () => ''
      },
    },
    data() {
      return {
        payment: {
          guid: '',
          expenseType: '',
          description: '',
          totalAmount: 0,
          paidBy: {
            guid: '',
            name: ''
          },
          originalPaymentDate: new Date(),
          notPayableReason: '',
          notPayableReasonTxtPart1: '',
          notPayableReasonTxtPart2: '',
          notPayableReasonUrl: '',
          reimbursementAmount: 0,
          owedBy: {
            guid: '',
            name: ''
          },
          reimbursementPaymentDate: new Date(),
          date: new Date(),
          amount: 0,
          alreadyPaid: false,
          changeable: false,
          myShare: 0,
          coparentsShare: 0,
          note: '',
          scheduled: '',
          paymentStatus: '',
          payor: {
            guid: '',
            name: ''
          },
          recipient: {
            guid: '',
            name: ''
          },
          submittedBy: {
            guid: '',
            name: ''
          },
          children: '',
          commentCount: 0,
          currency: '',
          attachments: [],
          canMarkAsPaid: null
        },
        showPay: false,
        checkedExpenses: [],
        payDropMenu: false,
        toPayGuid: '',
        guidChild: this.guid,
        searchItem: ':',
        discuss: false
      };
    },
    watch: {
      guidChild: function(val) {
        if (val !== '') {
          this.getExpense(val);
        }
      },
      $route: function (val) {
        this.guidChild = val.params.id;
      }
    },
    mounted() {
      if (this.guid !== "") {
        this.getExpense(this.guid);
        this.discuss = this.$route.params.discuss;
      }
    },
    methods: {
      ...mapActions({
        findByGuidSpousalAction: SPOUSAL_MAINTENANCE_FIND_BY_GUID,
        findByGuidChildAction: CHILD_MAINTENANCE_FIND_BY_GUID,
        findByGuidSharedAction: SHARED_EXPENSES_FIND_BY_GUID,
        deleteAction: DELETE_EXPENSE,
        markAsPaidAction: MARK_AS_PAID
      }),
      handlePaymentDropdown () {
        this.payDropMenu = true
      },
      noHandlePaymentDropdown () {
        this.payDropMenu = false
      },
      textNotPayableReason () {
        switch (this.payment.notPayableReason) {
          case('bothUsersNotAbleToCreateOrReceiveTransfer'):
            this.payment.notPayableReasonUrl = 'PaymentMethods';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_bothUsersNotAbleToCreateOrRecieveTransferPart1;
            this.payment.notPayableReasonTxtPart2 = this.$lang.messages.tp_bothUsersNotAbleToCreateOrRecieveTransferPart2;
            return;
          case('userNotAbleToCreateOrReceiveTransfer'):
            this.payment.notPayableReasonUrl = 'PaymentMethods';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_userNotAbleToCreateOrReceiveTransferPart1;
            this.payment.notPayableReasonTxtPart2 = this.$lang.messages.tp_userNotAbleToCreateOrReceiveTransferPart2;
            return;
          case('expenseHasPendingTransaction'):
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_expenseHasPendingTransaction;
            this.payment.notPayableReasonTxtPart2 = '';
            return;
          case('currentUserIsNotPayor'):
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_currentUserIsNotPayor;
            this.payment.notPayableReasonTxtPart2 = '';
            return;
          case('recipientIsRecordKeepingProfile'):
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_recipientIsRecordKeepingProfile;
            this.payment.notPayableReasonTxtPart2 = '';
            return;
          case('recipientCanNotReceiveFunds'):
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_recipientCanNotReceiveFunds;
            this.payment.notPayableReasonTxtPart2 = '';
            return;
          case('paymentIsPaid'):
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = this.$lang.messages.tp_paymentIsPaid;
            this.payment.notPayableReasonTxtPart2 = '';
            return;
          default:
            this.payment.notPayableReasonUrl = '';
            this.payment.notPayableReasonTxtPart1 = '';
            this.payment.notPayableReasonTxtPart2 = '';
            return;
        }
      },
      getExpense(guid) {
        if (this.type === this.$ALIMONY_EXPENSE_TYPE) {
          this.findByGuidSpousalAction(guid)
          .then(response => {
            this.payment.guid = response.data.data.guid;
            this.payment.expenseType = response.data.data.expenseType;
            this.payment.date = response.data.data.payments[0].paymentDate;
            this.payment.amount = response.data.data.payments[0].amount;
            this.payment.note = response.data.data.note;
            this.payment.scheduled = response.data.data.scheduled === null ? 'No' : response.data.data.scheduled;
            this.payment.paymentStatus = response.data.data.payments[0].paymentStatus;
            this.payment.submittedBy = response.data.data.payments[0].submittedBy;
            this.payment.payor = response.data.data.payments[0].payor;
            this.payment.recipient = response.data.data.payments[0].recipient;
            this.payment.changeable = response.data.data.payments[0].changeable;
            this.payment.payable = response.data.data.payable;
            this.payment.attachments = response.data.data.attachments;
            this.payment.notPayableReason = response.data.data.notPayableReason;
            this.payment.canMarkAsPaid = response.data.data.canMarkAsPaid;

            this.payment.commentCount = response.data.data.commentCount;

            this.payment.currency = response.data.data.payments[0].currency;

            this.checkedExpenses.push(this.payment);

            if (this.queryPay && !this.showPay && this.checkedExpenses.length >= 1 && this.payment.payable) {
              this.showPayExpenseModal();
              this.showPay = true
            }

            // Tooltip for current payment
            this.textNotPayableReason();

            this.$emit('status-payment', this.payment.paymentStatus);
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          });
        }
        else if (this.type === this.$CHILD_EXPENSE_TYPE) {
          this.payment.children = '';
          this.findByGuidChildAction(guid)
          .then(response => {
            this.payment.guid = response.data.data.guid;
            this.payment.expenseType = response.data.data.expenseType;
            this.payment.date = response.data.data.payments[0].paymentDate;
            this.payment.amount = response.data.data.payments[0].amount;
            this.payment.note = response.data.data.note;
            this.payment.scheduled = response.data.data.scheduled === null ? 'No' : response.data.data.scheduled;
            this.payment.paymentStatus = response.data.data.payments[0].paymentStatus;
            this.payment.submittedBy = response.data.data.payments[0].submittedBy;
            this.payment.payor = response.data.data.payments[0].payor;
            this.payment.recipient = response.data.data.payments[0].recipient;
            this.payment.changeable = response.data.data.payments[0].changeable;
            this.payment.payable = response.data.data.payable;
            this.payment.attachments = response.data.data.attachments;
            this.payment.notPayableReason = response.data.data.notPayableReason;
            this.payment.canMarkAsPaid = response.data.data.canMarkAsPaid;

            response.data.data.children.forEach(element => {
              this.payment.children = this.payment.children + ',' + element.name
            });
            if (this.payment.children.substring(0, 1) === ',') {
              this.payment.children = this.payment.children.substring(1, this.payment.children.length)
            }
            if (this.payment.children.substring(this.payment.children.length - 1, this.payment.children.length) === ",") {
              this.payment.children = this.payment.children.substring(0, this.payment.children.length - 1)
            }

            this.payment.commentCount = response.data.data.commentCount;

            this.payment.currency = response.data.data.payments[0].currency;

            this.checkedExpenses.push(this.payment);

            if (this.queryPay && !this.showPay && this.checkedExpenses.length >= 1 && this.payment.payable) {
              this.showPayExpenseModal();
              this.showPay = true
            }

            // Tooltip for current payment
            this.textNotPayableReason();

            this.$emit('status-payment', this.payment.paymentStatus);
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          });
        }
        else if (this.type === this.$SHARED_EXPENSE_TYPE) {
          this.payment.children = '';
          this.findByGuidSharedAction(guid)
          .then(response => {
            this.payment.guid = response.data.data.guid;
            this.payment.description = response.data.data.description;
            this.payment.attachments = response.data.data.attachments;
            this.payment.notPayableReason = response.data.data.notPayableReason;
            this.payment.canMarkAsPaid = response.data.data.canMarkAsPaid;

            response.data.data.children.forEach(element => {
              this.payment.children = this.payment.children + ',' + element.name
            });
            if (this.payment.children.substring(0, 1) === ',') {
              this.payment.children = this.payment.children.substring(1, this.payment.children.length)
            }
            if (this.payment.children.substring(this.payment.children.length - 1, this.payment.children.length) === ",") {
              this.payment.children = this.payment.children.substring(0, this.payment.children.length - 1)
            }

            response.data.data.payments.forEach(payment => {
              if (payment.paymentType === 'Original payment') {
                this.payment.totalAmount = payment.amount;
                this.payment.paidBy = payment.payor;
                this.payment.originalPaymentDate = payment.paymentDate;
                this.payment.submittedBy = payment.submittedBy
              } else if (payment.paymentType === 'Reimbursement payment') {
                this.payment.reimbursementAmount = payment.reimbursementAmount;
                this.payment.owedBy = payment.payor;
                this.payment.reimbursementPaymentDate = payment.paymentDate;
                this.payment.paymentStatus = payment.paymentStatus;
                this.payment.changeable = payment.changeable;
                this.payment.recipient = payment.payor
              }
            });

            this.payment.scheduled = response.data.data.scheduled === null ? 'No' : 'Yes';
            this.payment.note = response.data.data.note;
            this.payment.expenseType = response.data.data.expenseType;

            this.payment.coparentsShare = Math.round(((100 * this.payment.reimbursementAmount) / this.payment.totalAmount) * 100) / 100;
            this.payment.myShare = Math.round((100 - this.payment.coparentsShare) * 100) / 100;

            this.payment.commentCount = response.data.data.commentCount;

            this.payment.payable = response.data.data.payable;
            this.payment.currency = response.data.data.payments[0].currency;

            this.checkedExpenses.push(this.payment);

            if (this.queryPay && !this.showPay && this.checkedExpenses.length >= 1 && this.payment.payable) {
              this.showPayExpenseModal();
              this.showPay = true
            }

            // Tooltip for current payment
            this.textNotPayableReason();

            this.$emit('status-payment', this.payment.paymentStatus);
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          });
        }

      },
      deleteModalOpen(guid, type, typeOfDeletion) {
        this.$refs.deleteModalComponent.show(guid, type, typeOfDeletion);
      },
      confimationModalOpen(guid) {
        this.toPayGuid = guid;
        this.$refs.confirmationModal.show();
      },
      deleteExpense() {
        this.deleteAction(this.guidChild)
        .then(() => {
          this.$router.push({ name: "Unpaid" });
          this.$snotify.success(this.$lang.messages.sn_paymentSuccessDelete, 'SUCCESS')
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(error.response.data.status.desc, 'ERROR')
          }
        });
      },
      showPayExpenseModal() {
        this.$refs.payExpenseDetails.show(this.checkedExpenses)
      },
      markAsPaid() {
        this.markAsPaidAction(this.toPayGuid)
        .then(() => {
          this.$snotify.success(this.$lang.messages.sn_paymentSuccesMarkedAsPaid, 'SUCCESS');
          this.getExpense(this.guidChild);
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      },
      computedRoute(expenseType) {
        return (expenseType === this.$ALIMONY_EXPENSE_TYPE ?
          'AddPaymentSpousalMaintenance' : expenseType === this.$CHILD_EXPENSE_TYPE ?
          'AddPaymentChildMaintenance' : 'AddPaymentSharedExpenses');
      }
    }
  };
</script>
